var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
let CrmCardContent = class CrmCardContent extends Vue {
    constructor() {
        super(...arguments);
        this.decisorLevels = ['Alto', 'Baixo', 'Médio', 'Não Classificado'];
        this.decisorDepartments = [
            'Administrativo',
            'Comercial',
            'Financeiro',
            'Gestão',
            'Industrial',
            'Jurídico',
            'Marketing',
            'Proprietários',
            'Recursos Humanos',
            'Suprimento',
            'TI',
            'Operacional',
            'Outros',
            'Saúde',
        ];
    }
};
__decorate([
    Prop({ default: () => '' })
], CrmCardContent.prototype, "crmName", void 0);
__decorate([
    Prop({ default: () => '' })
], CrmCardContent.prototype, "crmDescription", void 0);
__decorate([
    Prop({ default: () => '' })
], CrmCardContent.prototype, "crmSubtitle", void 0);
__decorate([
    Prop({ default: () => '' })
], CrmCardContent.prototype, "crmIcon", void 0);
__decorate([
    Prop({ default: () => '' })
], CrmCardContent.prototype, "tutorialVideoLink", void 0);
__decorate([
    Prop({ default: () => [] })
], CrmCardContent.prototype, "companyFields", void 0);
__decorate([
    Prop({ default: () => [] })
], CrmCardContent.prototype, "decisorFields", void 0);
__decorate([
    Prop({ default: () => [] })
], CrmCardContent.prototype, "questions", void 0);
__decorate([
    Prop({ default: () => [] })
], CrmCardContent.prototype, "observations", void 0);
CrmCardContent = __decorate([
    Component({
        name: 'CrmCardContent',
    })
], CrmCardContent);
export default CrmCardContent;
